import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { Normalize } from "styled-normalize";
import { ThemeProvider } from "styled-components";
import App from "./App";
import theme from "./theme";
import * as serviceWorker from "./serviceWorker";

ReactDOM.render(
  <Router>
    <ThemeProvider theme={theme}>
      <React.Fragment>
        <Normalize />
        <App />
      </React.Fragment>
    </ThemeProvider>
  </Router>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
